var map = {
	"./abomasnow-f.gif": 92312,
	"./abomasnow-mega.gif": 44048,
	"./abomasnow.gif": 74141,
	"./abra.gif": 13600,
	"./absol-mega.gif": 72174,
	"./absol.gif": 99923,
	"./accelgor.gif": 97866,
	"./aegislash-blade.gif": 80566,
	"./aegislash.gif": 72511,
	"./aerodactyl.gif": 68562,
	"./aggron.gif": 602,
	"./aipom-f.gif": 11433,
	"./aipom.gif": 21872,
	"./alakazam-f.gif": 1947,
	"./alakazam-mega.gif": 19693,
	"./alakazam.gif": 37350,
	"./alcremie-caramel.gif": 66678,
	"./alcremie-caramelswirl.gif": 4763,
	"./alcremie-lemon.gif": 42000,
	"./alcremie-lemoncream.gif": 6654,
	"./alcremie-matcha.gif": 81811,
	"./alcremie-matchacream.gif": 95867,
	"./alcremie-mint.gif": 36031,
	"./alcremie-mintcream.gif": 86287,
	"./alcremie-rainbow.gif": 82199,
	"./alcremie-rainbowswirl.gif": 75432,
	"./alcremie-rubycream.gif": 28043,
	"./alcremie-rubyswirl.gif": 30060,
	"./alcremie-salted.gif": 29176,
	"./alcremie-saltedcream.gif": 69958,
	"./alcremie.gif": 62146,
	"./alomomola.gif": 11469,
	"./altaria.gif": 72068,
	"./amaura.gif": 37237,
	"./ambipom-f.gif": 57772,
	"./ambipom.gif": 40385,
	"./amoonguss.gif": 46394,
	"./ampharos-mega.gif": 98666,
	"./ampharos.gif": 12119,
	"./anorith.gif": 55537,
	"./applin.gif": 47444,
	"./araquanid.gif": 74024,
	"./arbok.gif": 93177,
	"./arcanine.gif": 30051,
	"./arceus-bug.gif": 33130,
	"./arceus-dark.gif": 81380,
	"./arceus-dragon.gif": 82849,
	"./arceus-electric.gif": 38029,
	"./arceus-fairy.gif": 69323,
	"./arceus-fighting.gif": 33634,
	"./arceus-fire.gif": 1700,
	"./arceus-flying.gif": 8317,
	"./arceus-ghost.gif": 80837,
	"./arceus-grass.gif": 51378,
	"./arceus-ground.gif": 27353,
	"./arceus-ice.gif": 26717,
	"./arceus-normal.gif": 12233,
	"./arceus-poison.gif": 40240,
	"./arceus-psychic.gif": 68437,
	"./arceus-rock.gif": 623,
	"./arceus-steel.gif": 1901,
	"./arceus-water.gif": 14341,
	"./arceus.gif": 60139,
	"./archen.gif": 32447,
	"./archeops.gif": 85921,
	"./arctibax.gif": 29860,
	"./arctovish.gif": 25439,
	"./ariados.gif": 95253,
	"./armaldo.gif": 520,
	"./aron.gif": 7940,
	"./arrokuda.gif": 11951,
	"./articuno-galar.gif": 43973,
	"./articuno.gif": 31415,
	"./audino.gif": 14264,
	"./aurumoth.gif": 80415,
	"./avalugg.gif": 19531,
	"./axew.gif": 30589,
	"./azelf.gif": 63306,
	"./azumarill.gif": 20973,
	"./azurill.gif": 28231,
	"./bagon.gif": 21371,
	"./baltoy.gif": 5125,
	"./banette-mega.gif": 81874,
	"./banette.gif": 18703,
	"./barboach.gif": 23012,
	"./barraskewda.gif": 89377,
	"./basculegion-f.gif": 55939,
	"./basculegion.gif": 71966,
	"./basculin-bluestriped.gif": 36279,
	"./basculin-whitestriped.gif": 8314,
	"./basculin.gif": 29037,
	"./bastiodon.gif": 55291,
	"./bayleef.gif": 89982,
	"./beartic.gif": 37500,
	"./beautifly-f.gif": 9280,
	"./beautifly.gif": 90357,
	"./beedrill-mega.gif": 768,
	"./beedrill.gif": 47661,
	"./beheeyem.gif": 51512,
	"./beldum.gif": 76271,
	"./bellossom.gif": 96642,
	"./bellsprout.gif": 55630,
	"./bergmite.gif": 47787,
	"./bewear.gif": 76000,
	"./bibarel-f.gif": 41770,
	"./bibarel.gif": 42731,
	"./bidoof-f.gif": 85904,
	"./bidoof.gif": 78149,
	"./binacle.gif": 19960,
	"./bisharp.gif": 63911,
	"./blacephalon.gif": 23637,
	"./blastoise.gif": 99768,
	"./blaziken-f.gif": 46357,
	"./blaziken-mega.gif": 42771,
	"./blaziken.gif": 812,
	"./blissey.gif": 30585,
	"./blitzle.gif": 82534,
	"./boldore.gif": 22113,
	"./bonsly.gif": 22923,
	"./bouffalant.gif": 34874,
	"./bounsweet.gif": 70602,
	"./braixen.gif": 88557,
	"./braviary.gif": 66742,
	"./breloom.gif": 22312,
	"./brionne.gif": 12611,
	"./bronzong.gif": 80941,
	"./bronzor.gif": 44038,
	"./bruxish.gif": 44531,
	"./budew.gif": 42831,
	"./buizel-f.gif": 63550,
	"./buizel.gif": 94911,
	"./bulbasaur.gif": 11933,
	"./buneary.gif": 6480,
	"./burmy-sandy.gif": 22351,
	"./burmy-trash.gif": 23978,
	"./burmy.gif": 6179,
	"./butterfree-f.gif": 22887,
	"./butterfree.gif": 38418,
	"./buzzwole.gif": 38706,
	"./cacnea.gif": 99519,
	"./cacturne-f.gif": 50884,
	"./cacturne.gif": 73513,
	"./calyrex-ice.gif": 69994,
	"./calyrex.gif": 35496,
	"./camerupt-f.gif": 66766,
	"./camerupt.gif": 18575,
	"./carbink.gif": 26138,
	"./carkoal.gif": 6953,
	"./carnivine.gif": 49171,
	"./carracosta.gif": 23997,
	"./carvanha.gif": 66102,
	"./cascoon.gif": 62308,
	"./castform-rainy.gif": 31161,
	"./castform-snowy.gif": 87076,
	"./castform-sunny.gif": 26747,
	"./castform.gif": 51481,
	"./caterpie.gif": 61279,
	"./cawmodore.gif": 70509,
	"./celebi.gif": 6540,
	"./celesteela.gif": 36925,
	"./chandelure.gif": 46925,
	"./chansey.gif": 35911,
	"./charizard-megax.gif": 13479,
	"./charizard.gif": 85514,
	"./charjabug.gif": 80633,
	"./charmander.gif": 66371,
	"./charmeleon.gif": 24618,
	"./chatot.gif": 88829,
	"./cherrim-sunshine.gif": 53392,
	"./cherrim.gif": 62626,
	"./cherubi.gif": 60620,
	"./chewtle.gif": 62380,
	"./chienpao.gif": 14411,
	"./chikorita.gif": 39332,
	"./chimchar.gif": 77181,
	"./chimecho.gif": 76590,
	"./chinchou.gif": 64523,
	"./chingling.gif": 80421,
	"./chiyu.gif": 65250,
	"./cinccino.gif": 28578,
	"./cinderace-gmax.gif": 356,
	"./clamperl.gif": 35010,
	"./clauncher.gif": 74833,
	"./clawitzer.gif": 1203,
	"./claydol.gif": 19250,
	"./clefable.gif": 61830,
	"./clefairy.gif": 691,
	"./cleffa.gif": 90381,
	"./clobbopus.gif": 47343,
	"./clodsire.gif": 15917,
	"./cloyster.gif": 37075,
	"./coalossal-gmax.gif": 30679,
	"./coalossal.gif": 57099,
	"./cobalion.gif": 58857,
	"./cofagrigus.gif": 71884,
	"./colossoil-f.gif": 5158,
	"./colossoil.gif": 87607,
	"./combee-f.gif": 66594,
	"./combee.gif": 75091,
	"./combusken-f.gif": 49868,
	"./combusken.gif": 74209,
	"./comfey.gif": 37235,
	"./conkeldurr.gif": 4863,
	"./corphish.gif": 61850,
	"./corsola-galar.gif": 50383,
	"./corsola.gif": 25001,
	"./corviknight.gif": 55042,
	"./corvisquire.gif": 65488,
	"./cosmoem.gif": 89557,
	"./cosmog.gif": 19542,
	"./cottonee.gif": 72581,
	"./crabominable.gif": 32421,
	"./crabrawler.gif": 30123,
	"./cradily.gif": 17414,
	"./cranidos.gif": 5741,
	"./crawdaunt.gif": 85287,
	"./cresselia.gif": 55233,
	"./croagunk-f.gif": 93217,
	"./croagunk.gif": 85080,
	"./crobat.gif": 1957,
	"./croconaw.gif": 81732,
	"./crustle.gif": 8658,
	"./cryogonal.gif": 77416,
	"./cubchoo.gif": 57735,
	"./cubone.gif": 38812,
	"./cufant.gif": 4483,
	"./cursola.gif": 775,
	"./cutiefly.gif": 92043,
	"./cyndaquil.gif": 62904,
	"./darkrai.gif": 29410,
	"./darmanitan-galarzen.gif": 78024,
	"./darmanitan-zen.gif": 69415,
	"./darmanitan.gif": 39303,
	"./darumaka.gif": 57162,
	"./dedenne.gif": 17703,
	"./deerling-autumn.gif": 45937,
	"./deerling-summer.gif": 60260,
	"./deerling-winter.gif": 81996,
	"./deerling.gif": 83442,
	"./deino.gif": 36953,
	"./delcatty.gif": 93022,
	"./delibird.gif": 63407,
	"./deoxys-attack.gif": 65799,
	"./deoxys-defense.gif": 59909,
	"./deoxys-speed.gif": 46540,
	"./deoxys.gif": 42830,
	"./dewgong.gif": 46249,
	"./dewott.gif": 5273,
	"./dewpider.gif": 16132,
	"./dhelmise.gif": 23139,
	"./dialga-origin.gif": 25623,
	"./dialga.gif": 36552,
	"./diancie.gif": 4687,
	"./diglett-alola.gif": 13179,
	"./diglett.gif": 97883,
	"./ditto.gif": 76818,
	"./dodrio-f.gif": 56778,
	"./dodrio.gif": 11627,
	"./doduo-f.gif": 5254,
	"./doduo.gif": 12567,
	"./donphan-f.gif": 54681,
	"./donphan.gif": 5184,
	"./dracovish.gif": 61209,
	"./dracozolt.gif": 22342,
	"./dragalge.gif": 28435,
	"./dragapult.gif": 70008,
	"./dragonair.gif": 37517,
	"./dragonite.gif": 15765,
	"./drakloak.gif": 59751,
	"./drampa.gif": 17603,
	"./drapion.gif": 51359,
	"./dratini.gif": 46699,
	"./drednaw-gmax.gif": 67563,
	"./drednaw.gif": 25263,
	"./dreepy.gif": 39559,
	"./drifblim.gif": 11205,
	"./drifloon.gif": 37377,
	"./drilbur.gif": 25814,
	"./drizzile.gif": 27295,
	"./drowzee.gif": 4106,
	"./druddigon.gif": 70218,
	"./dubwool.gif": 9600,
	"./ducklett.gif": 57248,
	"./dugtrio-alola.gif": 91376,
	"./dugtrio.gif": 72456,
	"./dunsparce.gif": 92679,
	"./duosion.gif": 76273,
	"./duraludon.gif": 82964,
	"./durant.gif": 92326,
	"./dusclops.gif": 52737,
	"./dusknoir.gif": 1993,
	"./duskull.gif": 29946,
	"./dustox-f.gif": 30434,
	"./dustox.gif": 77043,
	"./dwebble.gif": 16211,
	"./eelektrik.gif": 90094,
	"./eelektross.gif": 9699,
	"./eevee-gmax.gif": 6398,
	"./eevee.gif": 6008,
	"./eiscue-noice.gif": 52057,
	"./eiscue.gif": 69600,
	"./ekans.gif": 82594,
	"./eldegoss.gif": 45324,
	"./electabuzz.gif": 48307,
	"./electivire.gif": 16408,
	"./electrike.gif": 59160,
	"./electrode.gif": 9007,
	"./elekid.gif": 37566,
	"./elgyem.gif": 36271,
	"./emboar.gif": 11484,
	"./emolga.gif": 97909,
	"./empoleon.gif": 19129,
	"./entei.gif": 57763,
	"./escavalier.gif": 21721,
	"./espeon.gif": 43868,
	"./eternatus.gif": 33850,
	"./excadrill.gif": 53408,
	"./exeggcute.gif": 66481,
	"./exeggutor-alola.gif": 82396,
	"./exeggutor.gif": 33748,
	"./exploud.gif": 73683,
	"./farfetchd-galar.gif": 65235,
	"./farfetchd.gif": 59413,
	"./fearow.gif": 43826,
	"./feebas.gif": 61912,
	"./fennekin.gif": 53536,
	"./feraligatr.gif": 45921,
	"./ferroseed.gif": 72503,
	"./ferrothorn.gif": 85788,
	"./finneon-f.gif": 71792,
	"./finneon.gif": 18277,
	"./flaaffy.gif": 88911,
	"./flabebe-blue.gif": 35518,
	"./flabebe-orange.gif": 47904,
	"./flabebe-white.gif": 70137,
	"./flabebe-yellow.gif": 95214,
	"./flabebe.gif": 85637,
	"./flareon.gif": 2393,
	"./fletchinder.gif": 12936,
	"./fletchling.gif": 88726,
	"./floatzel-f.gif": 83952,
	"./floatzel.gif": 27621,
	"./floette.gif": 44205,
	"./florges.gif": 57542,
	"./fluttermane.gif": 6125,
	"./flygon.gif": 85659,
	"./fomantis.gif": 12139,
	"./foongus.gif": 95155,
	"./forretress.gif": 39661,
	"./fraxure.gif": 9109,
	"./frigibax.gif": 47680,
	"./frillish-f.gif": 53972,
	"./frillish.gif": 51737,
	"./froakie.gif": 35863,
	"./froslass.gif": 31743,
	"./frosmoth.gif": 76032,
	"./furret.gif": 60586,
	"./gabite-f.gif": 7609,
	"./gabite.gif": 37792,
	"./gallade.gif": 7678,
	"./galvantula.gif": 55085,
	"./garbodor-gmax.gif": 91554,
	"./garbodor.gif": 17788,
	"./garchomp-f.gif": 16598,
	"./garchomp-mega.gif": 20154,
	"./garchomp.gif": 60839,
	"./gardevoir-mega.gif": 56180,
	"./gardevoir.gif": 91737,
	"./gastly.gif": 98134,
	"./gastrodon-east.gif": 38661,
	"./gastrodon.gif": 67301,
	"./genesect-burn.gif": 93946,
	"./genesect-chill.gif": 66393,
	"./genesect-douse.gif": 9799,
	"./genesect-shock.gif": 34393,
	"./genesect.gif": 93076,
	"./gengar.gif": 85642,
	"./geodude-alola.gif": 48957,
	"./geodude.gif": 52665,
	"./gholdengo.gif": 70801,
	"./gible-f.gif": 10172,
	"./gible.gif": 59857,
	"./gigalith.gif": 5339,
	"./gimmighoul.gif": 23616,
	"./girafarig-f.gif": 34493,
	"./girafarig.gif": 89892,
	"./giratina-origin.gif": 26514,
	"./giratina.gif": 79163,
	"./glaceon.gif": 91227,
	"./glalie-mega.gif": 36677,
	"./glalie.gif": 11278,
	"./glameow.gif": 28012,
	"./glastrier.gif": 48571,
	"./gligar-f.gif": 24183,
	"./gligar.gif": 97730,
	"./glimmet.gif": 88005,
	"./gliscor.gif": 36017,
	"./gloom-f.gif": 10323,
	"./gloom.gif": 62126,
	"./golbat-f.gif": 87264,
	"./golbat.gif": 21717,
	"./goldeen-f.gif": 65409,
	"./goldeen.gif": 87320,
	"./golduck.gif": 44403,
	"./golem-alola.gif": 41286,
	"./golem.gif": 65018,
	"./golett.gif": 95601,
	"./golurk.gif": 24288,
	"./goodra-hisui.gif": 3331,
	"./goodra.gif": 60750,
	"./goomy.gif": 68113,
	"./gorebyss.gif": 19166,
	"./gothita.gif": 20896,
	"./gothitelle.gif": 58433,
	"./gothorita.gif": 32349,
	"./gougingfire.gif": 23556,
	"./granbull.gif": 82851,
	"./graveler-alola.gif": 23066,
	"./graveler.gif": 1278,
	"./greattusk.gif": 35094,
	"./greninja.gif": 38658,
	"./grimer-alola.gif": 49306,
	"./grimer.gif": 31038,
	"./grimmsnarl.gif": 2210,
	"./grookey.gif": 20460,
	"./grotle.gif": 57341,
	"./groudon-primal.gif": 13586,
	"./groudon.gif": 93636,
	"./grovyle.gif": 95406,
	"./growlithe.gif": 30147,
	"./grubbin.gif": 51355,
	"./grumpig.gif": 6305,
	"./gulpin-f.gif": 13090,
	"./gulpin.gif": 87955,
	"./gumshoos.gif": 61183,
	"./gurdurr.gif": 94693,
	"./gyarados-f.gif": 10427,
	"./gyarados.gif": 75366,
	"./hakamoo.gif": 48994,
	"./happiny.gif": 31291,
	"./hariyama.gif": 25516,
	"./hatenna.gif": 60339,
	"./hatterene-gmax.gif": 31438,
	"./hatterene.gif": 64168,
	"./haunter.gif": 2835,
	"./haxorus.gif": 39174,
	"./heatmor.gif": 17370,
	"./heatran.gif": 93779,
	"./helioptile.gif": 7271,
	"./heracross-f.gif": 11033,
	"./heracross.gif": 84096,
	"./herdier.gif": 8243,
	"./hippopotas-f.gif": 5518,
	"./hippopotas.gif": 76015,
	"./hippowdon-f.gif": 20737,
	"./hippowdon.gif": 22648,
	"./hitmonchan.gif": 20133,
	"./hitmonlee.gif": 71173,
	"./hitmontop.gif": 49490,
	"./honchkrow.gif": 91089,
	"./honedge.gif": 64538,
	"./hooh.gif": 80828,
	"./hoopa-unbound.gif": 87345,
	"./hoopa.gif": 31069,
	"./hoothoot.gif": 65102,
	"./hoppip.gif": 85370,
	"./horsea.gif": 86058,
	"./houndoom-f.gif": 58862,
	"./houndoom.gif": 2383,
	"./houndour.gif": 89374,
	"./huntail.gif": 59153,
	"./hydrapple.gif": 42119,
	"./hydreigon.gif": 21961,
	"./hypno-f.gif": 91533,
	"./hypno.gif": 84788,
	"./igglybuff.gif": 41631,
	"./illumise.gif": 19454,
	"./impidimp.gif": 31947,
	"./incineroar.gif": 64108,
	"./indeedee-f.gif": 21306,
	"./indeedee.gif": 87803,
	"./infernape.gif": 8168,
	"./inkay.gif": 120,
	"./inteleon.gif": 76384,
	"./ironhands.gif": 99018,
	"./ironmoth.gif": 208,
	"./ironthorns.gif": 21422,
	"./ironvaliant.gif": 89365,
	"./ivysaur.gif": 91265,
	"./jangmoo.gif": 72323,
	"./jellicent-f.gif": 55249,
	"./jellicent.gif": 36264,
	"./jigglypuff.gif": 78975,
	"./jirachi.gif": 96372,
	"./jolteon.gif": 53487,
	"./joltik.gif": 43779,
	"./jumpluff.gif": 3507,
	"./jynx.gif": 80923,
	"./kabuto.gif": 22182,
	"./kabutops.gif": 41793,
	"./kadabra-f.gif": 80869,
	"./kadabra.gif": 2140,
	"./kakuna.gif": 68497,
	"./kangaskhan.gif": 28919,
	"./karrablast.gif": 64459,
	"./kartana.gif": 42378,
	"./kecleon.gif": 35151,
	"./keldeo-resolute.gif": 44134,
	"./keldeo.gif": 29814,
	"./kingdra.gif": 58990,
	"./kingler.gif": 87520,
	"./kirlia.gif": 32806,
	"./klang.gif": 8817,
	"./klefki-front.gif": 57604,
	"./klefki.gif": 10206,
	"./klink.gif": 30885,
	"./klinklang.gif": 68029,
	"./koffing.gif": 63864,
	"./komala.gif": 811,
	"./kommoo.gif": 92512,
	"./krabby.gif": 93143,
	"./kricketot-f.gif": 93251,
	"./kricketot.gif": 59678,
	"./kricketune-f.gif": 10034,
	"./kricketune.gif": 28803,
	"./krokorok.gif": 61478,
	"./krookodile.gif": 29821,
	"./kyogre-primal.gif": 70595,
	"./kyogre.gif": 80739,
	"./kyurem-black.gif": 24003,
	"./kyurem-white.gif": 6413,
	"./kyurem.gif": 51177,
	"./lairon.gif": 67421,
	"./lampent.gif": 96247,
	"./landorus-therian.gif": 16650,
	"./landorus.gif": 48754,
	"./lanturn.gif": 42290,
	"./lapras.gif": 11557,
	"./larvesta.gif": 61258,
	"./larvitar.gif": 19537,
	"./latias-mega.gif": 6613,
	"./latias.gif": 69598,
	"./latios-mega.gif": 27203,
	"./latios.gif": 57084,
	"./leafeon.gif": 71940,
	"./leavanny.gif": 92956,
	"./ledian-f.gif": 44646,
	"./ledian.gif": 80407,
	"./ledyba-f.gif": 60840,
	"./ledyba.gif": 82797,
	"./lickilicky.gif": 54034,
	"./lickitung.gif": 76082,
	"./liepard.gif": 26391,
	"./lileep.gif": 49937,
	"./lilligant-hisui.gif": 36083,
	"./lilligant.gif": 66238,
	"./lillipup.gif": 21475,
	"./linoone-galar.gif": 53600,
	"./linoone.gif": 44270,
	"./litleo.gif": 20263,
	"./litten.gif": 37878,
	"./litwick.gif": 56927,
	"./lombre.gif": 17811,
	"./lopunny.gif": 81909,
	"./lotad.gif": 89900,
	"./loudred.gif": 34675,
	"./lucario-mega.gif": 64974,
	"./lucario.gif": 96851,
	"./ludicolo-f.gif": 29606,
	"./ludicolo.gif": 46295,
	"./lugia.gif": 29156,
	"./lumineon-f.gif": 86824,
	"./lumineon.gif": 87917,
	"./lunala.gif": 73765,
	"./lunatone.gif": 6568,
	"./lurantis.gif": 81698,
	"./luvdisc.gif": 21184,
	"./luxio-f.gif": 50720,
	"./luxio.gif": 62741,
	"./luxray-f.gif": 44422,
	"./luxray.gif": 86967,
	"./lycanroc-dusk.gif": 54753,
	"./lycanroc-midnight.gif": 1694,
	"./lycanroc.gif": 2161,
	"./machamp.gif": 45677,
	"./machoke.gif": 45788,
	"./machop.gif": 17248,
	"./magby.gif": 62184,
	"./magcargo.gif": 10929,
	"./magearna-original.gif": 15014,
	"./magearna.gif": 2350,
	"./magikarp-f.gif": 12215,
	"./magikarp.gif": 80674,
	"./magmar.gif": 61461,
	"./magmortar.gif": 96496,
	"./magnemite.gif": 28675,
	"./magneton.gif": 69651,
	"./magnezone.gif": 51094,
	"./makuhita.gif": 11140,
	"./malaconda.gif": 49594,
	"./malamar.gif": 32935,
	"./mamoswine-f.gif": 74789,
	"./mamoswine.gif": 18876,
	"./manaphy.gif": 20028,
	"./mandibuzz.gif": 72476,
	"./manectric-mega.gif": 98843,
	"./manectric.gif": 45060,
	"./mankey.gif": 26515,
	"./mantine.gif": 34340,
	"./mantyke.gif": 571,
	"./maractus.gif": 15454,
	"./mareep.gif": 97600,
	"./marill.gif": 99615,
	"./marowak-alola.gif": 60696,
	"./marowak.gif": 34608,
	"./marshadow.gif": 2850,
	"./marshtomp.gif": 66163,
	"./masquerain.gif": 9936,
	"./maushold-four.gif": 4948,
	"./maushold.gif": 37355,
	"./mawile-mega.gif": 86780,
	"./mawile.gif": 13169,
	"./medicham-f.gif": 92387,
	"./medicham-mega.gif": 21013,
	"./medicham.gif": 71454,
	"./meditite-f.gif": 25572,
	"./meditite.gif": 29513,
	"./meganium-f.gif": 3312,
	"./meganium.gif": 11845,
	"./melmetal.gif": 34261,
	"./meloetta-pirouette.gif": 72013,
	"./meloetta.gif": 90909,
	"./meltan.gif": 71333,
	"./meowth-alola.gif": 45054,
	"./meowth-galar.gif": 21548,
	"./meowth-gmax.gif": 75528,
	"./meowth.gif": 12274,
	"./mesprit.gif": 59134,
	"./metagross.gif": 93551,
	"./metang.gif": 36556,
	"./metapod.gif": 90726,
	"./mew.gif": 18451,
	"./mewtwo-mega-x.gif": 86621,
	"./mewtwo-mega-y.gif": 21188,
	"./mewtwo-megax.gif": 90798,
	"./mewtwo-megay.gif": 65415,
	"./mewtwo.gif": 30439,
	"./mienfoo.gif": 74375,
	"./mienshao.gif": 44296,
	"./mightyena.gif": 91546,
	"./milcery.gif": 71255,
	"./milotic-f.gif": 42304,
	"./milotic.gif": 9525,
	"./miltank.gif": 6208,
	"./mimejr.gif": 66934,
	"./mimikyu-busted.gif": 15957,
	"./mimikyu.gif": 71835,
	"./minccino.gif": 79796,
	"./minior-blue.gif": 49477,
	"./minior-green.gif": 25378,
	"./minior-indigo.gif": 66819,
	"./minior-meteor.gif": 5349,
	"./minior-orange.gif": 73927,
	"./minior-violet.gif": 63520,
	"./minior-yellow.gif": 33381,
	"./minior.gif": 4332,
	"./minun.gif": 69283,
	"./miraidon.gif": 30307,
	"./misdreavus.gif": 69863,
	"./mismagius.gif": 5517,
	"./mollux.gif": 52489,
	"./moltres.gif": 8424,
	"./monferno.gif": 47850,
	"./morelull.gif": 54312,
	"./morpeko-hangry.gif": 10747,
	"./morpeko.gif": 39971,
	"./mothim.gif": 32484,
	"./mrmime.gif": 88587,
	"./mrrime.gif": 62698,
	"./mudbray.gif": 9246,
	"./mudkip.gif": 76708,
	"./mudsdale.gif": 20807,
	"./muk-alola.gif": 84711,
	"./muk.gif": 36999,
	"./munchlax.gif": 43902,
	"./munna.gif": 44789,
	"./murkrow-f.gif": 36826,
	"./murkrow.gif": 65979,
	"./musharna.gif": 85115,
	"./nacli.gif": 45001,
	"./naganadel.gif": 85993,
	"./natu.gif": 60924,
	"./necrozma-dawnwings.gif": 3786,
	"./necrozma-duskmane.gif": 72318,
	"./necrozma-ultra.gif": 16286,
	"./necrozma.gif": 66487,
	"./necturna.gif": 98642,
	"./nidoking.gif": 37403,
	"./nidoqueen.gif": 15119,
	"./nidoranf.gif": 63753,
	"./nidoranm.gif": 23574,
	"./nidorina.gif": 4362,
	"./nidorino.gif": 92800,
	"./nihilego.gif": 17459,
	"./nincada.gif": 54332,
	"./ninetales-alola.gif": 52377,
	"./ninetales.gif": 21253,
	"./ninjask.gif": 28956,
	"./noctowl.gif": 21032,
	"./noibat.gif": 20321,
	"./nosepass.gif": 47260,
	"./numel-f.gif": 11724,
	"./numel.gif": 1569,
	"./nuzleaf-f.gif": 64520,
	"./nuzleaf.gif": 24237,
	"./obstagoon.gif": 60340,
	"./octillery-f.gif": 32756,
	"./octillery.gif": 83129,
	"./oddish.gif": 55319,
	"./omanyte.gif": 38553,
	"./omastar.gif": 35727,
	"./onix.gif": 18042,
	"./orbeetle-gmax.gif": 24410,
	"./oricorio-pau.gif": 34091,
	"./oricorio-pompom.gif": 24279,
	"./oricorio-sensu.gif": 33735,
	"./oshawott.gif": 77672,
	"./overqwil.gif": 74791,
	"./pachirisu-f.gif": 8497,
	"./pachirisu.gif": 58920,
	"./pajantom.gif": 90042,
	"./palkia.gif": 91046,
	"./palossand.gif": 25361,
	"./palpitoad.gif": 32972,
	"./pancham.gif": 23940,
	"./pangoro.gif": 9680,
	"./panpour.gif": 87489,
	"./pansage.gif": 52447,
	"./pansear.gif": 87558,
	"./paras.gif": 72091,
	"./parasect.gif": 80253,
	"./patrat.gif": 4934,
	"./pawniard.gif": 52968,
	"./pelipper.gif": 963,
	"./perrserker.gif": 4639,
	"./persian-alola.gif": 3378,
	"./persian.gif": 94038,
	"./petilil.gif": 56269,
	"./phanpy.gif": 64258,
	"./phantump.gif": 82445,
	"./pheromosa.gif": 19286,
	"./phione.gif": 5961,
	"./pichu.gif": 70543,
	"./pidgeot.gif": 63976,
	"./pidgeotto.gif": 72335,
	"./pidgey.gif": 3542,
	"./pidove.gif": 88503,
	"./pignite.gif": 43208,
	"./pikachu-alola.gif": 70123,
	"./pikachu-f.gif": 3306,
	"./pikachu-hoenn.gif": 34500,
	"./pikachu-kalos.gif": 31798,
	"./pikachu-original.gif": 29941,
	"./pikachu-partner.gif": 6818,
	"./pikachu-sinnoh.gif": 85249,
	"./pikachu-starter-f.gif": 7484,
	"./pikachu-starter.gif": 1841,
	"./pikachu-unova.gif": 50443,
	"./pikachu-world.gif": 8940,
	"./pikachu.gif": 11499,
	"./pikipek.gif": 6793,
	"./piloswine-f.gif": 85541,
	"./piloswine.gif": 73468,
	"./pincurchin.gif": 49227,
	"./pineco.gif": 88758,
	"./pinsir.gif": 67155,
	"./piplup.gif": 58460,
	"./plasmanta.gif": 62547,
	"./plusle.gif": 12791,
	"./pokestarblackbelt.gif": 66477,
	"./pokestarblackdoor.gif": 16518,
	"./pokestarbrycenman.gif": 63300,
	"./pokestarf00.gif": 81613,
	"./pokestarf002.gif": 63869,
	"./pokestargiant.gif": 25528,
	"./pokestarhumanoid.gif": 70248,
	"./pokestarmonster.gif": 10993,
	"./pokestarmt.gif": 29266,
	"./pokestarmt2.gif": 95680,
	"./pokestarsmeargle.gif": 40471,
	"./pokestarspirit.gif": 66454,
	"./pokestartransport.gif": 47264,
	"./pokestarufo.gif": 68791,
	"./pokestarufo2.gif": 13111,
	"./pokestarwhitedoor.gif": 22684,
	"./politoed-f.gif": 37381,
	"./politoed.gif": 5532,
	"./poliwag.gif": 78043,
	"./poliwhirl.gif": 44168,
	"./poliwrath.gif": 62620,
	"./ponyta-galar.gif": 82277,
	"./ponyta.gif": 10967,
	"./poochyena.gif": 26624,
	"./popplio.gif": 52287,
	"./porygon.gif": 43990,
	"./porygon2.gif": 29788,
	"./porygonz.gif": 96644,
	"./primarina.gif": 89944,
	"./primeape.gif": 76973,
	"./prinplup.gif": 71698,
	"./probopass.gif": 35505,
	"./psyduck.gif": 84337,
	"./pupitar.gif": 57331,
	"./purrloin.gif": 36349,
	"./purugly.gif": 62482,
	"./pyroar-f.gif": 66226,
	"./pyroar.gif": 17699,
	"./pyukumuku.gif": 10546,
	"./quagsire-f.gif": 57326,
	"./quagsire.gif": 67791,
	"./quilava.gif": 25839,
	"./quilladin.gif": 16243,
	"./qwilfish.gif": 75923,
	"./raboot.gif": 23893,
	"./raichu-alola.gif": 79872,
	"./raichu-f.gif": 25569,
	"./raichu.gif": 82648,
	"./raikou.gif": 1485,
	"./ralts.gif": 4184,
	"./rampardos.gif": 94723,
	"./rapidash.gif": 2332,
	"./raticate-alola.gif": 1809,
	"./raticate-f.gif": 92824,
	"./raticate.gif": 28349,
	"./rattata-alola.gif": 69675,
	"./rattata-f.gif": 66506,
	"./rattata.gif": 39339,
	"./rayquaza-mega.gif": 45221,
	"./rayquaza.gif": 50510,
	"./regice.gif": 11605,
	"./regidrago.gif": 24938,
	"./regigigas.gif": 34568,
	"./regirock.gif": 77666,
	"./registeel.gif": 88058,
	"./relicanth-f.gif": 22763,
	"./relicanth.gif": 63062,
	"./remoraid.gif": 72321,
	"./reshiram.gif": 66443,
	"./reuniclus.gif": 61664,
	"./rhydon-f.gif": 76489,
	"./rhydon.gif": 15184,
	"./rhyhorn-f.gif": 61631,
	"./rhyhorn.gif": 89466,
	"./rhyperior-f.gif": 51057,
	"./rhyperior.gif": 96104,
	"./ribombee.gif": 60123,
	"./riolu.gif": 93165,
	"./robots.txt": 54444,
	"./rockruff.gif": 14190,
	"./roggenrola.gif": 75512,
	"./rolycoly.gif": 95421,
	"./rookidee.gif": 39128,
	"./roselia-f.gif": 16290,
	"./roselia.gif": 9779,
	"./roserade-f.gif": 58856,
	"./roserade.gif": 63245,
	"./rotom-fan.gif": 31233,
	"./rotom-frost.gif": 19576,
	"./rotom-heat.gif": 20212,
	"./rotom-mow.gif": 72769,
	"./rotom-wash.gif": 9063,
	"./rotom.gif": 74105,
	"./rowlet.gif": 64749,
	"./rowlett.gif": 70583,
	"./rufflet.gif": 46248,
	"./runerigus.gif": 79288,
	"./sableye.gif": 82504,
	"./salamence-mega.gif": 97152,
	"./salamence.gif": 50509,
	"./samurott-hisui.gif": 10616,
	"./samurott.gif": 94965,
	"./sandaconda.gif": 88054,
	"./sandile.gif": 9116,
	"./sandshrew-alola.gif": 45621,
	"./sandshrew.gif": 66929,
	"./sandslash-alola.gif": 75363,
	"./sandslash.gif": 97315,
	"./sandygast.gif": 10108,
	"./sawk.gif": 65672,
	"./sawsbuck-autumn.gif": 45220,
	"./sawsbuck-summer.gif": 98057,
	"./sawsbuck-winter.gif": 59353,
	"./sawsbuck.gif": 89501,
	"./scatterbug.gif": 55282,
	"./sceptile.gif": 12599,
	"./scizor-f.gif": 39567,
	"./scizor-mega.gif": 36793,
	"./scizor.gif": 76810,
	"./scolipede.gif": 23178,
	"./scorbunny.gif": 51485,
	"./scrafty.gif": 67682,
	"./scraggy.gif": 85462,
	"./scyther-f.gif": 66589,
	"./scyther.gif": 66628,
	"./seadra.gif": 65402,
	"./seaking-f.gif": 77439,
	"./seaking.gif": 84730,
	"./sealeo.gif": 98545,
	"./seedot.gif": 80352,
	"./seel.gif": 9870,
	"./seismitoad.gif": 90124,
	"./sentret.gif": 12597,
	"./serperior.gif": 31365,
	"./servine.gif": 77112,
	"./seviper.gif": 39598,
	"./sewaddle.gif": 96011,
	"./sharpedo.gif": 69492,
	"./shaymin-sky.gif": 14563,
	"./shaymin.gif": 79611,
	"./shedinja.gif": 87658,
	"./shelgon.gif": 20840,
	"./shellder.gif": 36509,
	"./shellos-east.gif": 25448,
	"./shellos.gif": 19278,
	"./shelmet.gif": 99414,
	"./shieldon.gif": 98098,
	"./shiftry-f.gif": 40116,
	"./shiftry.gif": 28441,
	"./shiinotic.gif": 12020,
	"./shinx-f.gif": 35859,
	"./shinx.gif": 16142,
	"./shroomish.gif": 82766,
	"./shuckle.gif": 42307,
	"./shuppet.gif": 98019,
	"./sigilyph.gif": 97979,
	"./siilvally-rock.gif": 33243,
	"./silcoon.gif": 48439,
	"./silicobra.gif": 72706,
	"./silvally-bug.gif": 15983,
	"./silvally-dark.gif": 45855,
	"./silvally-dragon.gif": 97682,
	"./silvally-electric.gif": 88530,
	"./silvally-fairy.gif": 49810,
	"./silvally-fighting.gif": 5049,
	"./silvally-fire.gif": 65152,
	"./silvally-flying.gif": 93170,
	"./silvally-ghost.gif": 27932,
	"./silvally-grass.gif": 19207,
	"./silvally-ground.gif": 30962,
	"./silvally-ice.gif": 56940,
	"./silvally-poison.gif": 32987,
	"./silvally-psychic.gif": 67328,
	"./silvally-rock.gif": 19664,
	"./silvally-steel.gif": 2496,
	"./silvally-water.gif": 39804,
	"./silvally.gif": 44718,
	"./simipour.gif": 97318,
	"./simisage.gif": 24664,
	"./simisear.gif": 66517,
	"./skarmory.gif": 6226,
	"./skiddo.gif": 76324,
	"./skiploom.gif": 19272,
	"./skitty.gif": 68174,
	"./skorupi.gif": 24801,
	"./skuntank.gif": 51645,
	"./slaking.gif": 75633,
	"./slakoth.gif": 79322,
	"./sliggoo-hisui.gif": 45289,
	"./sliggoo.gif": 38256,
	"./slowbro-galar.gif": 28846,
	"./slowbro.gif": 83540,
	"./slowking-galar.gif": 44306,
	"./slowking.gif": 42752,
	"./slowpoke-galar.gif": 37836,
	"./slowpoke.gif": 85906,
	"./slugma.gif": 27393,
	"./slurpuff.gif": 14371,
	"./smeargle.gif": 28068,
	"./smoochum.gif": 30619,
	"./sneasel-f.gif": 82060,
	"./sneasel.gif": 45441,
	"./snivy.gif": 55789,
	"./snom.gif": 38917,
	"./snorlax.gif": 3941,
	"./snorunt.gif": 24809,
	"./snover-f.gif": 54818,
	"./snover.gif": 11379,
	"./snubbull.gif": 38203,
	"./sobble.gif": 68713,
	"./solgaleo.gif": 83696,
	"./solosis.gif": 83766,
	"./solrock.gif": 57815,
	"./spearow.gif": 18371,
	"./spheal.gif": 95853,
	"./spinarak.gif": 36599,
	"./spinda.gif": 15671,
	"./spiritomb.gif": 61441,
	"./spoink.gif": 99682,
	"./spritzee.gif": 48664,
	"./squirtle.gif": 67415,
	"./stakataka.gif": 86601,
	"./stantler.gif": 78087,
	"./staraptor-f.gif": 48725,
	"./staraptor.gif": 87820,
	"./staravia-f.gif": 55224,
	"./staravia.gif": 72285,
	"./starly-f.gif": 78966,
	"./starly.gif": 61159,
	"./starmie.gif": 3089,
	"./staryu.gif": 15772,
	"./steelix-f.gif": 5361,
	"./steelix-mega.gif": 93799,
	"./steelix.gif": 30472,
	"./steenee.gif": 77619,
	"./stonjourner.gif": 43731,
	"./stoutland.gif": 22354,
	"./stufful.gif": 46627,
	"./stunfisk.gif": 74123,
	"./stunky.gif": 966,
	"./sudowoodo-f.gif": 48428,
	"./sudowoodo.gif": 30497,
	"./suicune.gif": 80368,
	"./sunflora.gif": 24206,
	"./sunkern.gif": 51504,
	"./surskit.gif": 92897,
	"./swablu.gif": 65156,
	"./swadloon.gif": 79695,
	"./swalot-f.gif": 20719,
	"./swalot.gif": 21194,
	"./swampert.gif": 13561,
	"./swanna.gif": 18146,
	"./swellow.gif": 751,
	"./swepa.gif": 69088,
	"./swinub.gif": 85376,
	"./swirlix.gif": 79536,
	"./swoobat.gif": 39347,
	"./sylveon.gif": 97370,
	"./tadbulb.gif": 91004,
	"./taillow.gif": 1142,
	"./talonflame.gif": 39451,
	"./tandemaus.gif": 12240,
	"./tangela.gif": 8650,
	"./tangrowth-f.gif": 26995,
	"./tangrowth.gif": 98190,
	"./tapubulu.gif": 69260,
	"./tapukoko.gif": 79606,
	"./tapulele.gif": 36026,
	"./tatsugiri-droopy.gif": 36150,
	"./tatsugiri-stretchy.gif": 4167,
	"./tatsugiri.gif": 25626,
	"./tauros.gif": 62876,
	"./teddiursa.gif": 45057,
	"./tentacool.gif": 71981,
	"./tentacruel.gif": 11449,
	"./tepig.gif": 89901,
	"./terapagos-stellar.gif": 26258,
	"./terapagos-terastal.gif": 42871,
	"./terapagos.gif": 15754,
	"./terrakion.gif": 13195,
	"./throh.gif": 86625,
	"./thundurus-therian.gif": 87708,
	"./thundurus.gif": 20748,
	"./thwackey.gif": 76630,
	"./timburr.gif": 53547,
	"./tinglu.gif": 42711,
	"./tirtouga.gif": 15753,
	"./togedemaru.gif": 78505,
	"./togekiss.gif": 22939,
	"./togepi.gif": 55556,
	"./togetic.gif": 63543,
	"./tomohawk-f.gif": 96999,
	"./tomohawk.gif": 24530,
	"./torchic-f.gif": 21925,
	"./torchic.gif": 23900,
	"./torkoal.gif": 82316,
	"./tornadus-therian.gif": 48414,
	"./tornadus.gif": 93478,
	"./torterra.gif": 7865,
	"./totodile.gif": 15278,
	"./toucannon.gif": 97053,
	"./toxapex.gif": 80831,
	"./toxel.gif": 56764,
	"./toxicroak-f.gif": 71519,
	"./toxicroak.gif": 50746,
	"./toxtricity-gmax.gif": 45491,
	"./toxtricity.gif": 60759,
	"./tranquill.gif": 98356,
	"./trapinch.gif": 27567,
	"./treecko.gif": 43087,
	"./trevenant.gif": 99667,
	"./tropius.gif": 27018,
	"./trubbish.gif": 71303,
	"./trumbeak.gif": 9453,
	"./turtonator.gif": 1218,
	"./turtwig.gif": 6768,
	"./tympole.gif": 46478,
	"./tynamo.gif": 50692,
	"./typenull.gif": 50209,
	"./typhlosion.gif": 29087,
	"./tyranitar-mega.gif": 65199,
	"./tyranitar.gif": 37568,
	"./tyrantrum.gif": 182,
	"./tyrogue.gif": 12775,
	"./tyrunt.gif": 8782,
	"./umbreon.gif": 53918,
	"./unfezant-f.gif": 70480,
	"./unfezant.gif": 14693,
	"./unown-b.gif": 14192,
	"./unown-c.gif": 3689,
	"./unown-d.gif": 83842,
	"./unown-e.gif": 91915,
	"./unown-em.gif": 9056,
	"./unown-exclamation.gif": 73425,
	"./unown-f.gif": 39396,
	"./unown-g.gif": 78653,
	"./unown-h.gif": 88246,
	"./unown-i.gif": 49359,
	"./unown-j.gif": 17384,
	"./unown-k.gif": 29569,
	"./unown-l.gif": 88762,
	"./unown-m.gif": 54083,
	"./unown-n.gif": 92668,
	"./unown-o.gif": 47253,
	"./unown-p.gif": 5166,
	"./unown-q.gif": 37255,
	"./unown-question.gif": 73362,
	"./unown-r.gif": 43296,
	"./unown-s.gif": 11353,
	"./unown-t.gif": 62386,
	"./unown-u.gif": 10363,
	"./unown-v.gif": 49428,
	"./unown-w.gif": 18125,
	"./unown-x.gif": 56806,
	"./unown-y.gif": 11679,
	"./unown-z.gif": 1592,
	"./unown.gif": 51433,
	"./ursaluna-bloodmoon.gif": 43269,
	"./ursaluna.gif": 9233,
	"./ursaring-f.gif": 87808,
	"./ursaring.gif": 36181,
	"./uxie.gif": 58691,
	"./vanillish.gif": 63006,
	"./vanillite.gif": 41746,
	"./vanilluxe.gif": 65386,
	"./vaporeon.gif": 21222,
	"./venipede.gif": 72774,
	"./venomoth.gif": 89092,
	"./venonat.gif": 82309,
	"./venusaur-f.gif": 90962,
	"./venusaur.gif": 62467,
	"./vespiquen.gif": 94974,
	"./vibrava.gif": 43349,
	"./victini.gif": 24466,
	"./victreebel.gif": 12393,
	"./vigoroth.gif": 6938,
	"./vikavolt.gif": 64820,
	"./vileplume-f.gif": 95982,
	"./vileplume.gif": 35439,
	"./virizion.gif": 15502,
	"./vivillon-archipelago.gif": 49713,
	"./vivillon-continental.gif": 5629,
	"./vivillon-elegant.gif": 56012,
	"./vivillon-fancy.gif": 21029,
	"./vivillon-garden.gif": 43657,
	"./vivillon-highplains.gif": 1113,
	"./vivillon-icysnow.gif": 14014,
	"./vivillon-jungle.gif": 19593,
	"./vivillon-marine.gif": 75796,
	"./vivillon-modern.gif": 47831,
	"./vivillon-monsoon.gif": 30949,
	"./vivillon-ocean.gif": 43932,
	"./vivillon-pokeball.gif": 63382,
	"./vivillon-polar.gif": 93246,
	"./vivillon-river.gif": 552,
	"./vivillon-sandstorm.gif": 37303,
	"./vivillon-savanna.gif": 81586,
	"./vivillon-sun.gif": 9488,
	"./vivillon-tundra.gif": 10182,
	"./vivillon.gif": 96365,
	"./volbeat.gif": 54737,
	"./volcanion.gif": 60269,
	"./volcarona.gif": 6783,
	"./volkraken.gif": 14227,
	"./voltorb-hisui.gif": 4371,
	"./voltorb.gif": 92350,
	"./vullaby.gif": 64973,
	"./vulpix-alola.gif": 71570,
	"./vulpix.gif": 97590,
	"./wailmer.gif": 95039,
	"./wailord.gif": 49598,
	"./walrein.gif": 4644,
	"./wartortle.gif": 72684,
	"./watchog.gif": 44037,
	"./weavile-f.gif": 98868,
	"./weavile.gif": 64473,
	"./weedle.gif": 71724,
	"./weepinbell.gif": 49255,
	"./weezing-galar.gif": 37483,
	"./weezing.gif": 49677,
	"./wget.exe": 40862,
	"./whimsicott.gif": 40939,
	"./whirlipede.gif": 19099,
	"./whiscash.gif": 40666,
	"./whismur.gif": 69229,
	"./wigglytuff.gif": 46544,
	"./wimpod.gif": 42380,
	"./wingull.gif": 64668,
	"./wishiwashi-school.gif": 16279,
	"./wishiwashi.gif": 14026,
	"./wobbuffet-f.gif": 83559,
	"./wobbuffet.gif": 24818,
	"./wochien.gif": 77083,
	"./woobat.gif": 81016,
	"./wooloo.gif": 72183,
	"./wooper-f.gif": 80045,
	"./wooper-paldea.gif": 10122,
	"./wooper.gif": 85748,
	"./wormadam-sandy.gif": 36570,
	"./wormadam-trash.gif": 94567,
	"./wormadam.gif": 790,
	"./wurmple.gif": 64838,
	"./wynaut.gif": 51806,
	"./wyrdeer.gif": 91608,
	"./xatu-f.gif": 16047,
	"./xatu.gif": 84042,
	"./xerneas.gif": 77272,
	"./xurkitree.gif": 49467,
	"./yamask.gif": 92088,
	"./yamper.gif": 58582,
	"./yanma.gif": 23148,
	"./yanmega.gif": 96604,
	"./yungoos.gif": 92214,
	"./yveltal.gif": 75859,
	"./zacian-crowned.gif": 13457,
	"./zacian.gif": 47528,
	"./zamazenta-crowned.gif": 95314,
	"./zamazenta.gif": 58939,
	"./zangoose.gif": 54926,
	"./zapdos-galar.gif": 86141,
	"./zapdos.gif": 57327,
	"./zebstrika.gif": 15591,
	"./zekrom.gif": 13446,
	"./zeraora.gif": 14314,
	"./zigzagoon-galar.gif": 29572,
	"./zigzagoon.gif": 5322,
	"./zoroark-hisui.gif": 87135,
	"./zoroark.gif": 56858,
	"./zorua.gif": 68009,
	"./zubat-f.gif": 66599,
	"./zubat.gif": 46674,
	"./zweilous.gif": 10886,
	"./zygarde-10.gif": 78290,
	"./zygarde.gif": 15156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74225;